import { render, staticRenderFns } from "./DraggableArticle0004.vue?vue&type=template&id=7960ccb4&"
import script from "./DraggableArticle0004.vue?vue&type=script&lang=js&"
export * from "./DraggableArticle0004.vue?vue&type=script&lang=js&"
import style0 from "./DraggableArticle0004.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports